<template>
  <div class="container">
    <div class="title">
      <h1>{{ msg }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      type: String,
      default: 'title',
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.title {
  padding-bottom: 20px;
  h1 {
    display: flex;
    justify-content: center;
    font-size: 2.2rem;
    z-index: 1;
  }
  h1::before,
  h1::after {
    content: "";
    display: block;
    height: 4px;
    background-color: #aaa;
    margin: auto;
    flex-grow: 1;
  }
  h1::before {
    margin-right: 2em;
  }
  h1::after {
    margin-left: 2em;
  }
}
@media screen and (max-width: 800px){
.container{
  padding: 0;
  .title {
      h1{
        font-size: 2rem;
      }
      h1::before,
      h1::after{
        display: none;
      }
    }
  }
}
</style>
